export const formatToIndianTime = (dateString) => {
    if (!dateString) return '';
    
    try {
        // Create a date object
        const date = new Date(dateString);
        
        // Check if date is valid
        if (isNaN(date.getTime())) {
            console.error('Invalid date string:', dateString);
            return '';
        }
        
        // Format the date in Indian timezone
        return date.toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).replace(',', ' -');
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};

// Format for table display (without seconds)
export const formatToIndianTimeShort = (dateString) => {
    if (!dateString) return '';
    
    try {
        const date = new Date(dateString);
        
        if (isNaN(date.getTime())) {
            console.error('Invalid date string:', dateString);
            return '';
        }
        
        return date.toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).replace(',', ' -');
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};